import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0px;
    font-family: 'Poppins', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #F8F8F8;
    font-weight: 400;

    a {
      transition: all 0.8s ease 0s;
    }

    a:hover {
      color: #ff690a;
    }
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  div.Mui-disabled {
    background-color: rgba(0,0,0,0.1); 
  }

  button.MuiButton-contained.Mui-disabled {
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)
  }

  .MuiSelect-selectMenu.Mui-disabled {
    background-color: rgba(0,0,0,0);
    color: rgba(0,0,0,0.38);
  }

  .MuiFormControlLabel-label {
    font-weight: bold;
  }

  .MuiOutlinedInput-root { 
    background-color: #FFF;
  }

  .MuiTableCell-root {
    font-family: 'Poppins';
  }

  .MuiButton-endIcon  {
    width: 48px;
    height: 48px;
    background-color: rgba(255, 255, 255, 0.12);
    align-items: center;
    justify-content: center;
    margin-left: 15px !important;
  }

`;
